import { render, staticRenderFns } from "./DocumentNotesTabContent.vue?vue&type=template&id=8abe2c3e&scoped=true&"
import script from "./DocumentNotesTabContent.vue?vue&type=script&lang=js&"
export * from "./DocumentNotesTabContent.vue?vue&type=script&lang=js&"
import style0 from "./DocumentNotesTabContent.vue?vue&type=style&index=0&id=8abe2c3e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8abe2c3e",
  null
  
)

export default component.exports